import type { TablePaginationConfig } from "antd";

export const getDefaultPagination = (
  overrides?: Partial<TablePaginationConfig>
): TablePaginationConfig => ({
  defaultPageSize: 10,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total: number, range: [number, number]) =>
    `${range[0]}-${range[1]} of ${total} items`,
  pageSizeOptions: ["10", "20", "50", "100"],
  position: ["bottomRight"],
  ...overrides,
});
